import { observable, action } from 'mobx';
import agent from '../../api/agent';

export default new class artistDetailsStore{

@observable publicApiLimit=25;
@observable publicApiOffset=0;
@observable privateApiLimit=25;
@observable privateApiOffset=0;

    @action getArtistDetailsPrivate(id,hideTheLoader){
        return agent.Artists.getArtistDetailsPrivate(id,hideTheLoader,{limit : this.privateApiLimit , offset : this.privateApiOffset})
        
    }
    @action getArtistDetailsPublic(id,hideTheLoader){
        return agent.Artists.getArtistDetailsPublic(id,hideTheLoader,{limit : this.publicApiLimit , offset : this.publicApiOffset})
    }
    @action getArtistArtworksPrivate(id){
        return agent.Artists.getArtistArtworksPrivate(id,null)

    }
 loadMore(identifier){
     if(identifier=="public"){
        this.publicApiOffset= this.publicApiOffset + 25;
        // this.publicApiLimit = 0;
    }else {
        this.privateApiOffset= this.privateApiOffset + 25;

     }
 }
 reset(){
        this.publicApiOffset= 0;

        this.privateApiOffset= 0;
 }
    @action getAllArtistsCategory(query){
        return agent.Artists.getAllArtistsCategory(query,{limit : 4 , offset : 0})
    }
    @action getAllArtistsCategoryPublic(query){
        return agent.Artists.getArtistsCategoryPublic(query,{limit : 4 , offset : 0})
    }
}


// WEBPACK FOOTER //
// ./src/stores/artistsStore/artistDetailsStore.js